<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">Ícones</h1>
    <div class="mb-8 flex flex-col">
      <text-input label="Filtro" v-model="filterValue" @input="filterIcons" />
    </div>

    <div
      v-for="(PACK, NAME) in FILTERED_ICONS"
      :key="`Ícones ${NAME}`"
      class="mb-4 bg-white rounded-md shadow overflow-x-auto"
    >
      <span class="font-bold text-lg ml-1 mt-1">
        {{ NAME }}
      </span>

      <div class="mt-4 flex flex-wrap">
        <div
          v-for="ICON in PACK"
          :key="`${ICON.prefix} fa-${ICON.iconName}`"
          class="max-w-sm rounded shadow-lg overflow-hidden w-2/12 m-4 cursor-pointer"
          @click="copy(ICON.prefix, ICON.iconName)"
        >
          <div class="px-6 py-4">
            <div class="font-bold text-xl mb-2 text-center">
              <font-awesome-icon :icon="`${ICON.prefix} fa-${ICON.iconName}`" size="lg" />
            </div>

            <p class="text-gray-700 text-sm text-center">
              {{ ICON.prefix }} fa-{{ ICON.iconName }}
            </p>

            <p
              v-if="copied === `${ICON.prefix} fa-${ICON.iconName}`"
              class="text-indigo text-xs text-center"
            >
              Ícone copiado!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '../../Shared/TextInput.vue'
import Layout from '@/Shared/Layout'
import { far as FontAwesomeRegularIcons } from '@fortawesome/free-regular-svg-icons'
import { fas as FontAwesomeSolidIcons } from '@fortawesome/free-solid-svg-icons'

export default {
  components: { TextInput },
  metaInfo: { title: 'Ícones' },
  layout: Layout,
  data() {
    return {
      copied: null,
      get ICONS() {
        const make = (icons) =>
          Object.values(icons).filter((icon, index, self) => {
            return self.findIndex((selfIcon) => selfIcon.iconName === icon.iconName) === index
          })

        return {
          Regulares: make(FontAwesomeRegularIcons),
          Sólidos: make(FontAwesomeSolidIcons),
        }
      },
      FILTERED_ICONS: this.ICONS,
      filterValue: '',
    }
  },
  mounted() {
    this.FILTERED_ICONS = this.ICONS
  },
  methods: {
    copy(prefix, name) {
      const icon = `${prefix} fa-${name}`

      this.copied = icon

      navigator.clipboard.writeText(icon)
    },
    filterIcons() {
      const keyword = this.filterValue.toLowerCase()

      if (keyword) {
        this.FILTERED_ICONS = {}
        for (const [packName, icons] of Object.entries(this.ICONS)) {
          this.FILTERED_ICONS[packName] = icons.filter((ICON) => {
            let fullString = ICON.prefix + ' fa-' + ICON.iconName

            return fullString.toLowerCase().includes(keyword)
          })
        }
      } else {
        this.FILTERED_ICONS = this.ICONS
      }
    },
  },
}
</script>
